function replaceNodeByComment(el, vnode) {
    const comment = document.createComment(' ')

    Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined
    })

    vnode.text = ' '
    vnode.elm = comment
    vnode.isComment = true
    vnode.context = undefined
    vnode.tag = undefined
    vnode.data.directives = undefined

    if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment
    }

    if (el.parentNode) {
        el.parentNode.replaceChild(comment, el)
    }
}

export default function(el, bindings, vnode) {
    const rolesToCheck = Array.isArray(bindings.value) ? bindings.value : [bindings.value]
    const rolesFound = rolesToCheck.filter(role => window.Portal.roles.includes(role))
    const hasRole = bindings.modifiers.not ? !rolesFound.length > 0 : rolesFound.length > 0

    if (!hasRole) {
        replaceNodeByComment(el, vnode)
    }
}
